import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from '@mui/material';

const dataProviderName = 'cars/contract';
const model = 'cars/contract';
const wizardName = 'ContractExtensionModifyDate';
const wizardAction = 'contractExtensionModifyDate';

const ContractExtensionModifyDate = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const item = params.item;
    const child = params.child;

    const { doAction, item: providerItem, errorMessage, errors, saving, success } = useDataProvider(
        dataProviderName,
        params.multipart
    );

    const detailConfig = {
        tabs: [
            {
                name: 'contract_extension_modify_date',
                fieldsets: [
                    {
                        name: 'contract_extension_modify_date',
                        fields: {
                            contractReajustmentEnd_at: {
                                type: 'date',
                                className: 'col-12',
                                icon: 'faCalendarPencil',
                                format: 'date',
                            },
                        },
                    },
                ],
            },
        ],
        validation: [],
    };

    const [editing, setEditing] = useState(true);

    useEffect(() => {
        if (success) {
            (async () => {
                try {
                    await params.handleClose(params.uid, providerItem?.data ?? item);
                } catch (e) {
                    /* drawer close */
                }
            })();
        }
    }, [success]);

    const handleSave = async (data) => {
        doAction &&
            doAction({
                action: wizardAction,
                model: model || dataProviderName,
                data: {
                    ...data,
                    childContractId: child?._id ?? child?.id,
                },
            });
    };

    if (!item) {
        return (
            <Backdrop open style={{ backgroundColor: 'white' }}>
                <CircularProgress />
            </Backdrop>
        );
    }

    return (
        <DetailComponent
            values={{
                id: item._id ?? item.id,
                contractReajustmentEnd_at: item.contractReajustmentEnd_at,
            }}
            modelName={model.split('/')[1]}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            onEditing={setEditing}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={
                userCapabilities && userCapabilities[dataProviderName + '.contractextension']
            }
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Insert the new contract readjustment date')}
                />
            }
            {...params}
        />
    );
};

export default ContractExtensionModifyDate;
